<template>
    <div>
        <psi-page-title
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="pageBreadcrumbs"
        >
        </psi-page-title>

        <!-- Content always starts with a v-card  -->
        <v-card class="mt-4">
            <v-card-text>
                <psi-toolbar
                    title="Students"
                    :filters="[]"
                    :quicklinks="[]"
                    :actions="[]"
                    :view-option.sync="viewOption"
                    hide-view-options
                    @refresh="refresh"
                    close-on-select
                    close-on-clear
                >
                </psi-toolbar>
                <v-row>
                    <v-spacer></v-spacer>
                    <psi-form-text-field
                        id="search"
                        name="search"
                        :value="search"
                        class="mt-4 mr-3"
                        style="max-width: 450px"
                        :dark="false"
                        label="Search"
                        clearable
                        autofocus
                        placeholder="Search by student name or email"
                        icon="mdi-magnify"
                        @input="debounceHandler"
                    />
                </v-row>
                <program-paginator
                    v-if="students.to"
                    :per_page.sync="per_page"
                    :current_page.sync="current_page"
                    :total_pages="students.last_page"
                    :to="students.to"
                    :from="students.from"
                    :total="students.total"
                />
                <keep-alive>
                    <component
                        :loading="dataLoading"
                        :students="$_.get(students, 'data', [])"
                        :is="`student-${viewOption}`"
                    ></component>
                </keep-alive>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import HomeLink from "@/mixins/homelink";
import debounce from "lodash.debounce";

export default {
    name: "program-students",
    mixins: [HomeLink],
    components: {
        StudentList: () =>
            import("@components/program/components/ProgramStudentList"),
        ProgramStudentPaginator: () =>
            import("@components/program/components/ProgramPaginator"),
    },
    data() {
        return {
            page: {
                title: "Rent Well Students",
                icon: "mdi-account-multiple",
            },
            filters: [],
            quicklinks: [],
            selectedItems: [],
            search: "",
            viewOption: this.$vuetify.breakpoint.mobile ? "grid" : "list",
            per_page: this.$config("program.pagination.perPage"),
            current_page: 1, // start on page 1
        };
    },
    computed: {
        ...mapGetters("Programs", ["students", "dataLoading"]),
        pageBreadcrumbs() {
            return [
                Object.assign(
                    {
                        text: "Home",
                        disabled: false,
                    },
                    this.homeUrl
                ),
                {
                    text: "Students",
                    disabled: true,
                    to: "#",
                },
            ];
        },
    },
    methods: {
        ...mapActions("Programs", ["getStudents"]),
        getParams() {
            return this.search
                ? {
                      current_page: this.current_page,
                      per_page: this.per_page,
                      search: this.search,
                  }
                : {
                      current_page: this.current_page,
                      per_page: this.per_page,
                  };
        },
        refresh() {
            this.getStudents(this.getParams());
        },
        onSearch(term) {
            this.search = term;
            if (
                this.search === null ||
                this.search.length > 2 ||
                this.search.length === 0
            ) {
                this.refresh();
            }
        },
    },
    watch: {
        current_page() {
            this.refresh();
        },
        per_page() {
            // start at page 1 when changing per page counts
            this.current_page = 1;
            this.refresh();
        },
    },
    mounted() {
        this.refresh();
    },
    created() {
        this.debounceHandler = debounce((term) => {
            this.onSearch(term);
        }, 200);
    },
    beforeUnmount() {
        this.debouncedHandler.cancel();
    },
};
</script>

<style scoped>
</style>